import { useEffect, useState } from "react"
import { processGet, processPatch } from "../../../../services/api";
import { useAuth } from "../core/Auth";
import { useIntl } from "react-intl";


export function Group() {
  const intl = useIntl()
  const {logout} = useAuth()
  const [groups, setGroups] = useState<any>(null);
  const [tenandId, setTenantId] = useState<any>(null);
  const [showError, setShowError] = useState(false);
  useEffect (() => {

    const fetchGroups = async () => {
      try {
        const response:any = await processGet('me/groups');
        setGroups(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchGroups();
  },[]);

  const selectTenant = async () => {
    setShowError(false);
    if(!tenandId) {
      setShowError(true);
    }

    try {
      await processPatch(`auth/setTenantId/${tenandId}`);
      let tenantName = groups.find((group:any) => group.id == tenandId)?.group_name;

      console.log("groups", groups);
      console.log("tenandId", tenandId);
      localStorage.setItem('selectedTenant', tenantName);
      window.location.href = '/';
    } catch (error) {
      console.error(error);
    }

  }


  return <>
   <div className='d-flex justify-content-end mb-10'>
  <a href="javascript:void(0)" onClick={logout} className='text-primary'>Logout</a>
  </div>
  <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({id:"AUTH.ACCESS"})}</h1>
        <div className='text-gray-500 fw-semibold fs-6'>{intl.formatMessage({id:"AUTH.SELECT_TENANT"})}</div>
      </div>
 
 
  <select name="group" id="group" className='form-select' value={tenandId} onChange={(e) => setTenantId(e.target.value)}>
    <option value="">{intl.formatMessage({id:"AUTH.SELECT_TENANT"})}</option>
    {groups && groups.map((group:any) => (
      <option key={group.id} value={group.id}>{group.group_name}</option>
    ))}
  </select>
  {showError && <div className='alert alert-danger mt-10'>{intl.formatMessage({id:"AUTH.PLEASE_SELECT_TENANT"})}</div>}
  <button onClick={selectTenant} className='btn btn-primary mt-10 w-100'>Select</button>
  
  </>
}